export const AppConfig = {
  estateAdPath: '/inserieren/es-haus-inserieren-verkauf',
  estateAdPublishedPath: '/inserieren/eingestellt',
  userDashboardPath: '/mein-bereich',
  estateDetailsPath: '/expose/',
};
